import React, { forwardRef, Ref } from 'react';
import { GameTileBase, TSharedGameTileProps } from './GameTileUtils';
import { FeatureGamePage } from '../constants/translationConstants';
import '../../../../css/common/_gameTiles.scss';

export const SponsoredGameTile = forwardRef(
  (
    { translate, id, onTileClick, gameData }: TSharedGameTileProps,
    ref: Ref<HTMLDivElement>
  ): JSX.Element => {
    return (
      <div ref={ref} className='grid-item-container game-card-container'>
        <GameTileBase id={id} onTileClick={onTileClick} gameData={gameData}>
          <div className='game-card-native-ad'>
            <div className='native-ad-label'>{translate(FeatureGamePage.LabelSponsoredAd)}</div>
          </div>
        </GameTileBase>
      </div>
    );
  }
);

export default SponsoredGameTile;
